export default __webpack_public_path__ + "static/media/research_paper@2x.9c5207c7.png";